import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css"; // Importar Bootstrap
import { useDispatch, useSelector } from 'react-redux'; 
import * as XLSX from 'xlsx'; 

const PagoChequeList = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [respuesta, setRespuesta] = useState(null);
  const [paginaActual, setPaginaActual] = useState(1);
  const [itemsPorPagina] = useState(70); // Número de elementos por página
  const [chequesSeleccionados, setChequesSeleccionados] = useState([]); // Estado para los cheques seleccionados
  const [comentario, setComentario] = useState(""); // Estado para el comentario
  const [filtroCodigoEmpleado, setFiltroCodigoEmpleado] = useState(""); // Estado para el filtro de código de empleado
  const [filtroNombreEmpleado, setFiltroNombreEmpleado] = useState(""); // Estado para el filtro de nombre de empleado
  const { user } = useSelector(state => state.auth);  
  const [botonvalidar, setBotonValidar] = useState("");
  const [botonvalidar2, setBotonValidar2] = useState(""); 
  const [usuaioId, setUsuarioId] = useState(""); 


  // Función para obtener los datos iniciales (GET)
  const obtenerDatos = async () => {
    setLoading(true);
    setError(null);
    const perfilEncontrado = user.rol.find(perfil => perfil.Id_Perfil === 150000 || perfil.Id_Perfil === 150010 ||perfil.Id_Perfil === 150020); 
    const idPerfil = perfilEncontrado ? perfilEncontrado.Id_Perfil : null;
    
    console.log(perfilEncontrado) 
    console.log(idPerfil)

    const datos = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321",
      },
      Usr: {
        Codigo: "",
        UserNickName: "pierril",
      },
      DatosMetodo: {
        NombreMetodo: "ObtenerChequesEmpleados",
        Datos_Recibidos: JSON.stringify({ CodUsu: user.id_usuario, CodPerfil: idPerfil }),
      },
    };
  
    console.log(datos)
    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`;
  
    try {
      const response = await fetch(fetchDataUrl);
  
      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.status} ${response.statusText}`);
      }
  
      const data = await response.json();
      console.log('Respuesta de la API (GET):', data);
  
      // Parsear datos_Generados y acceder a PAGO_CHEQUE
      if (data.datos_Generados) {
        const datosGenerados = JSON.parse(data.datos_Generados); // Convertir de string a objeto
        if (datosGenerados.PAGO_CHEQUE) { 
          console.log(datosGenerados.PAGO_CHEQUE);
          setRespuesta(datosGenerados.PAGO_CHEQUE); // Asignar PAGO_CHEQUE al estado
        } else {
          console.error('PAGO_CHEQUE no encontrado o inválido:', datosGenerados);
          setError('No se encontraron datos generados en la respuesta.');
        }
      } else {
        console.error('datos_Generados no encontrado o inválido:', data);
        setError('No se encontraron datos generados en la respuesta.');
      }
    } catch (error) {
      console.error('Error al obtener los datos:', error);
      setError(error.message || 'Error al obtener los datos de la API.');
    } finally {
      setLoading(false);
    }
  };

  // Obtener los datos al cargar el componente
  useEffect(() => { 
    console.log(user);
    console.log(user.id_usuario) 
    const perfilEncontrado = user.rol.find(perfil => perfil.Id_Perfil === 150000 || perfil.Id_Perfil === 150010  ||  perfil.Id_Perfil === 150020); 
    const idPerfil = perfilEncontrado ? perfilEncontrado.Id_Perfil : null;
    
    console.log(perfilEncontrado) 
    console.log(idPerfil) 

    setUsuarioId(user.id_usuario); 

    console.log(usuaioId)

    if(idPerfil === 150000 || idPerfil === 150020 ){
        setBotonValidar("TRUE")
    }else{
        setBotonValidar("FALSE")
    } 
    if(idPerfil === 150000 || idPerfil === 150010 ){
      setBotonValidar2("TRUE")
  }else{
      setBotonValidar2("FALSE")
  }
    obtenerDatos();
  }, []);

  // Función para manejar el cambio en los checkboxes
  const handleCheckboxChange = (cheque) => {
    console.log("Cheque seleccionado:", cheque);
    console.log("Cheques seleccionados actuales:", chequesSeleccionados);
  
    const isAlreadySelected = chequesSeleccionados.some(
      (c) =>
        c["Codigo Empleado"] === cheque["Codigo Empleado"] &&
        c["Codigo Planilla"] === cheque["Codigo Planilla"] &&
        c["Salario a Pagar"] === cheque["Salario a Pagar"]
    );
  
    console.log("¿Ya está seleccionado?", isAlreadySelected);
  
    if (isAlreadySelected) {
      setChequesSeleccionados((prev) =>
        prev.filter(
          (c) =>
            !(
              c["Codigo Empleado"] === cheque["Codigo Empleado"] &&
              c["Codigo Planilla"] === cheque["Codigo Planilla"] &&
              c["Salario a Pagar"] === cheque["Salario a Pagar"]
            )
        )
      );
    } else {
      setChequesSeleccionados((prev) => [...prev, cheque]);
    }
  
    console.log("Cheques seleccionados después de la actualización:", chequesSeleccionados);
  };

  // Función para enviar los datos seleccionados (POST)
  const enviarDatosSeleccionados = async () => {
    setLoading(true);
    setError(null);
  
    const datos = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321",
      },
      User: {
        Codigo: "",
        UserNickName: "pierril",
      },
      Metodo: {
        NombreMetodo: "GenerarCheques",
        Datos_Recibidos: JSON.stringify(
          chequesSeleccionados.map((cheque) => ({
            CodPlanilla: cheque["Codigo Planilla Alternativo"],
            CodEmpleado: cheque["Codigo Empleado Alternativo"],
            NombreEmpleado: cheque["Empleado"],
            Comentario: cheque["Planilla"], // Usamos el comentario ingresado por el usuario
            Monto: cheque["Salario a Pagar"],
            DocEntry: null,
            UsuarioAutoriza: user.id_usuario, // Este valor será actualizado por la respuesta
          }))
        ),
        Datos_Generados: "",
      },
    };
  console.log(datos)
    try {
      const response = await fetch("https://appcorp.parma.com.gt/API/ReceptorDatos", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(datos),
      });
  
      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.status} ${response.statusText}`);
      }
  
      const data = await response.json();
      console.log('Respuesta de la API (POST):', data);
  
      // Procesar la respuesta para obtener los docEntry
      if (data.datos_Generados) {
        const datosGenerados = JSON.parse(data.datos_Generados); // Convertir de string a arreglo de objetos
  
        // Crear un mapa para asociar CodEmpleado con DocEntry
       /* const docEntryMap = new Map();
        datosGenerados.forEach((item) => {
          docEntryMap.set(item.CodEmpleado, item.DocEntry);
        });*/
  
        // Actualizar la lista principal de cheques con los docEntry
       /* const nuevaRespuesta = respuesta.map((cheque) => {
          const docEntry = docEntryMap.get(cheque["Codigo Empleado Alternativo"]);
          if (docEntry) {
            return { ...cheque, DocEntry: docEntry }; // Agregar el DocEntry al cheque
          }
          return cheque;
        });*/  
        alert('Proceso exitoso ')
        setRespuesta(""); 
        obtenerDatos();
  
      //  setRespuesta(nuevaRespuesta); // Actualizar el estado con la nueva lista
      }
    } catch (error) {
      console.error('Error al procesar la respuesta:', error);
      setError(error.message || 'Error al procesar la respuesta de la API.');
    } finally {
      setLoading(false);
    }
  };

  const enviarDatosSeleccionados2 = async () => {
    setLoading(true);
    setError(null);

    const datos = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321",
      },
      User: {
        Codigo: "",
        UserNickName: "pierril",
      },
      Metodo: {
        NombreMetodo: "RevisarCheques",
        Datos_Recibidos: JSON.stringify(
          chequesSeleccionados.map((cheque) => ({
            CodPlanilla: cheque["Codigo Planilla Alternativo"],
            CodEmpleado: cheque["Codigo Empleado"],
            CodEmpleadoAlt: cheque["Codigo Empleado Alternativo"],
            NombreEmpleado: cheque["Empleado"],
            Comentario: comentario, // Usamos el comentario ingresado por el usuario
            Monto: cheque["Salario a Pagar"],
            DocEntry: null, // Este valor será actualizado por la respuesta
          }))
        ),
        Datos_Generados: "",
      },
    };
  console.log(datos)
    try {
      const response = await fetch("https://appcorp.parma.com.gt/API/ReceptorDatos", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(datos),
      });
  
      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.status} ${response.statusText}`);
      }
  
      const data = await response.json();
      console.log('Respuesta de la API (POST):', data);
  
      // Procesar la respuesta para obtener los docEntry
      if (data.datos_Generados) {
        const datosGenerados = JSON.parse(data.datos_Generados); // Convertir de string a arreglo de objetos
  
        // Crear un mapa para asociar CodEmpleado con DocEntry
        console.log(datosGenerados)
  
        // Actualizar la lista principal de cheques con los docEntry
       alert('cheque processado con exito ')
       // setRespuesta(nuevaRespuesta); 
       // // Actualizar el estado con la nueva lista
        setRespuesta(""); 
        obtenerDatos();
      }
    } catch (error) {
      console.error('Error al procesar la respuesta:', error);
      setError(error.message || 'Error al procesar la respuesta de la API.');
    } finally {
      setLoading(false);
    }
  };
  // Función para filtrar los datos
  const filtrarDatos = (datos) => {
    return datos.filter((cheque) => {
      const coincideCodigo = filtroCodigoEmpleado
        ? cheque["Codigo Empleado Alternativo"].toString().includes(filtroCodigoEmpleado)
        : true;
      const coincideNombre = filtroNombreEmpleado
        ? cheque["Empleado"].toLowerCase().includes(filtroNombreEmpleado.toLowerCase())
        : true;
      return coincideCodigo && coincideNombre;
    });
  };



  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(respuesta);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Cheques");
    XLSX.writeFile(wb, "cheques.xlsx");
  }; 

  const seleccionarTodos = () => {
    if (chequesSeleccionados.length === itemsActuales.length) {
      // Si todos están seleccionados, deseleccionar todos
      setChequesSeleccionados([]);
    } else {
      // Si no, seleccionar todos
      setChequesSeleccionados([...itemsActuales]);
    }
  };

  // Calcular los índices de los elementos a mostrar
  const indexUltimoItem = paginaActual * itemsPorPagina;
  const indexPrimerItem = indexUltimoItem - itemsPorPagina;

  // Asegúrate de que respuesta sea un array antes de usar slice
  const itemsActuales = Array.isArray(respuesta)
    ? filtrarDatos(respuesta).slice(indexPrimerItem, indexUltimoItem)
    : [];


    const contarChequesPorPlanilla = (respuesta) => {
      if (!Array.isArray(respuesta)) {
        console.error("La respuesta no es un arreglo válido.");
        return { quincenal: 0, vacaciones: 0 };
      }
    
      // Filtrar y contar cheques de Planilla Quincenal
      const chequesQuincenal = respuesta.filter((cheque) =>
        cheque.Planilla.includes("Planilla Quincenal")
      );
    
      // Filtrar y contar cheques de Planilla de Vacaciones
      const chequesVacaciones = respuesta.filter((cheque) =>
        cheque.Planilla.includes("Planilla de Vacaciones")
      );
    
      return {
        quincenal: chequesQuincenal.length,
        vacaciones: chequesVacaciones.length,
      };
    };

    // Función para extraer el nombre de la planilla sin fecha y paréntesis
const extraerNombrePlanilla = (planilla) => {
  // Expresión regular para extraer el nombre antes del primer paréntesis
  const regex = /^(.*?)\s*\(/;
  const match = planilla.match(regex);
  return match ? match[1].trim() : planilla; // Devuelve el nombre o el texto original si no hay coincidencia
};

// Ejemplo de uso
const nombrePlanilla = extraerNombrePlanilla("Planilla Quincenal (Planta) (01/03/2025 - 15/03/2025)");
console.log(nombrePlanilla); // "Planilla Quincenal (Planta)" 

  // Contar cheques por tipo de planilla
  const conteoCheques = contarChequesPorPlanilla(respuesta);

  // Extraer el nombre de la planilla sin fecha y paréntesis
  const nombrePlanillaQuincenal = extraerNombrePlanilla("Planilla Quincenal (Planta) (01/03/2025 - 15/03/2025)");

  return (
    <div className="container mt-5">
      <h1 className=" mb-4">Lista de Cheques</h1>

      {/* Botón para obtener los datos (GET) */}
      <div className=" mb-4">
        <button
          className="btn btn-primary"
          onClick={obtenerDatos}
          disabled={loading}
        >
          {loading ? "Cargando..." : "Obtener Cheques"}
        </button>
      </div>

      {/* Campos de filtro */}
      <div className="mb-4">
        <div className="row">
          <div className="col-md-6">
            <label htmlFor="filtroCodigoEmpleado" className="form-label">Filtrar por Código de Empleado:</label>
            <input
              type="text"
              id="filtroCodigoEmpleado"
              className="form-control"
              value={filtroCodigoEmpleado}
              onChange={(e) => setFiltroCodigoEmpleado(e.target.value)}
              placeholder="Ingrese el código de empleado"
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="filtroNombreEmpleado" className="form-label">Filtrar por Nombre de Empleado:</label>
            <input
              type="text"
              id="filtroNombreEmpleado"
              className="form-control"
              value={filtroNombreEmpleado}
              onChange={(e) => setFiltroNombreEmpleado(e.target.value)}
              placeholder="Ingrese el nombre de empleado"
            />
          </div> 

        </div>
      </div>

 

      {/* Botón para enviar los datos seleccionados (POST) */}
     
      <div className=" mb-4"> 
      <button
        className="btn btn-info"
        onClick={seleccionarTodos}
        disabled={loading || !respuesta || respuesta.length === 0} 
        style={{marginRight: "30PX"}}
      >
        {chequesSeleccionados.length === itemsActuales.length ? "Deseleccionar Todos" : "Seleccionar Todos"}
       </button>
      {botonvalidar2 === "TRUE" && (
        <button
          className="btn btn-success"
          onClick={enviarDatosSeleccionados2}
          disabled={loading || chequesSeleccionados.length === 0}
        >
          {loading ? "Enviando..." : "Enviar Cheques Seleccionados"}
        </button> 
      )}
  {botonvalidar === "TRUE" && (
    <button
        className="btn btn-warning"
        onClick={enviarDatosSeleccionados}
        style={{ marginLeft: "40px", marginRight: "30px" }}
    >
        {loading ? "Enviando..." : "Enviar Cheques a SAP"}
    </button>
)}

      </div> 
      <div className="mb-4">
  <button
    className="btn btn-success"
    onClick={exportToExcel}
    disabled={loading || !respuesta || respuesta.length === 0}
  >
    Exportar a Excel
  </button>
  <div className="container mt-5">
      <h1 className="mb-4">Lista de Cheques</h1>

      {/* Mostrar el conteo de cheques */}
      <div className="mb-4">
        <h3>Conteo de Cheques</h3>
        <p>
          <strong>{nombrePlanillaQuincenal}:</strong> {conteoCheques.quincenal} cheques
        </p>
        <p>
          <strong>Planilla de Vacaciones:</strong> {conteoCheques.vacaciones} cheques
        </p>
      </div>

      {/* ... (resto de tu código) */}
    </div>
</div>

      {/* Mostrar errores */}
      {error && <div className="alert alert-danger">{error}</div>}

      {/* Mostrar los datos en una tabla */}
      {respuesta && (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
          <thead>
  <tr>
    <th>Seleccionar</th>
    <th>Código Empleado</th>
    <th>Código Empleado Alternativo</th>
    <th>Empleado</th>
    <th>Código Planilla</th>
    <th>Planilla</th>
    <th>Código Planilla Alternativo</th>
    <th>Salario a Pagar</th>
    <th>Estado</th>
    <th>DocEntry</th> {/* Nueva columna para DocEntry */}
  </tr>
</thead>
<tbody>
  {itemsActuales.map((cheque, index) => (
    <tr key={index}>
      <td>
        <input
          type="checkbox"
          checked={chequesSeleccionados.some(
            (c) => c["Codigo Empleado"] === cheque["Codigo Empleado"]  &&
            c["Codigo Planilla"] === cheque["Codigo Planilla"] &&
            c["Salario a Pagar"] === cheque["Salario a Pagar"]
          )}
          onChange={() => handleCheckboxChange(cheque)}
        />
      </td>
      <td>{cheque["Codigo Empleado"]}</td>
      <td>{cheque["Codigo Empleado Alternativo"]}</td>
      <td>{cheque["Empleado"]}</td>
      <td>{cheque["Codigo Planilla"]}</td>
      <td>{cheque["Planilla"]}</td>
      <td>{cheque["Codigo Planilla Alternativo"]}</td>
      <td>{cheque["Salario a Pagar"]}</td>
      <td>{cheque["Estado"]}</td>
      <td>{cheque["DocNum"]}</td> {/* Mostrar el DocEntry */}
    </tr>
  ))}
</tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PagoChequeList;